import { createBrowserRouter } from 'react-router-dom';

import { routes } from './routes';

const Router = createBrowserRouter(routes);

export default Router;
